<ng-template #afterTitleOperation>
    <app-switch-input id="operationActiveOnly" [form]="form" label="common.fields.activeOnly"></app-switch-input>
</ng-template>
<ng-template #afterTitleRegion>
    <app-switch-input id="regionActiveOnly" [form]="form" label="common.fields.activeOnly"></app-switch-input>
</ng-template>

<div class="flex flex-column gap">
    <app-table
        #operationTable
        [afterTitle]="afterTitleOperation"
        [tableTitle]="operationPrefix + 'label'"
        [translatePrefix]="operationPrefix"
        [gridData]="store.data.getSocialServiceOperations()"
        [additionalFilter]="additionalFilterOperation()"
        [refreshCallback]="store.api.getSocialServiceOperations"
        [refreshCallbackFragment]="getSocialServiceOperationsFrag"
        [columns]="operationColumns"
        [showColumnVisiblity]="true"
        [showClearFilter]="true"
        [showSearch]="true"
        (detailCallback)="openOperationDetail($event)"
        (createCallback)="openOperationDetail()"
        (deleteCallbackWithEvent)="deleteOperation($event)"
    ></app-table>

    <app-table
        #regionTable
        [afterTitle]="afterTitleRegion"
        [tableTitle]="regionPrefix + 'label'"
        [translatePrefix]="regionPrefix"
        [gridData]="store.data.getSocialServiceRegions()"
        [additionalFilter]="additionalFilterRegion()"
        [refreshCallback]="store.api.getSocialServiceRegions"
        [refreshCallbackFragment]="getSocialServiceRegionsFrag"
        [columns]="regionColumns"
        [showColumnVisiblity]="true"
        [showClearFilter]="true"
        [showSearch]="true"
        (detailCallback)="openRegionDetail($event)"
        (createCallback)="openRegionDetail()"
        (deleteCallbackWithEvent)="deleteRegion($event)"
    ></app-table>

    <app-service-type-residual-percent-table></app-service-type-residual-percent-table>

</div>
